<template>
	<div>
		<case-form :schema="schema" class="mt6" />

		<div class="xs-12 fs4 fw7 mb2 mt6">Past 2 Years</div>
		<j-accordion
			v-for="i in 4"
			:key="i"
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span class="mr1">Travel Details</span>
				{{ i }}
			</div>
			<div slot="body" class="p6 bg5">
				<case-form :schema="schemaTravelPast2Years(i)" :isBoxed="false" />
			</div>
		</j-accordion>

		<div class="xs-12 fs4 fw7 mb2 mt6">Next 2 Years</div>
		<j-accordion
			v-for="i in 4"
			:key="i"
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span class="mr1">Travel Details</span>
				{{ i }}
			</div>
			<div slot="body" class="p6 bg5">
				<case-form :schema="schemaTravelNext2Years(i)" :isBoxed="false" />
			</div>
		</j-accordion>

		<case-form :schema="schema2" class="mt6 mb6" />
		<div class="fs4 fw7 lh125 mt6 mb2">
			Provide travel pattern over the past 14 days:
		</div>
		<j-accordion
			v-for="i in 3"
			:key="i"
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span class="mr1">Travel Pattern</span>
				{{ i }}
			</div>
			<div slot="body" class="p6 bg5">
				<case-form :schema="schemaTravelPast14Days(i)" :isBoxed="false" />
			</div>
		</j-accordion>

		<case-form :schema="schemaOthers" class="mt6" />
	</div>
</template>

<script>
import CaseForm from "@/modules/caseManagement/components/CaseForm/CaseForm.vue"
import JAccordion from "@/components/JAccordion/"

export default {
	components: {
		CaseForm,
		JAccordion
	},

	data() {
		return {
			maxNumberOfList: 3
		}
	},

	computed: {
		schema() {
			return [
				{
					label:
						"Have you traveled or do you plan to travel outside your current country of residence?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0willTravelOutsideCountryOfResidence`,
					props: {
						suggest: {
							typeIncludes: `willTravelOutsideCountryOfResidence`
						},
						createOptions: {
							type: `willTravelOutsideCountryOfResidence`,
							dataType: "boolean"
						}
					}
				}
			]
		},
		schema2() {
			return [
				{
					label: `Have you travelled over the past 14 days?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasTravelledPast14Days`,
					props: {
						suggest: {
							typeIncludes: `hasTravelledPast14Days`
						},
						createOptions: {
							type: `hasTravelledPast14Days`,
							dataType: "boolean"
						}
					}
				}
			]
		},
		schemaOthers() {
			return [
				{
					label: "Do you plan to change your current country of residence?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasPlanToMigrate`,
					props: {
						suggest: {
							typeIncludes: `hasPlanToMigrate`
						},
						createOptions: {
							type: `hasPlanToMigrate`,
							dataType: "boolean"
						}
					}
				},
				{
					label:
						"Do you plan to live outside your current country of residence within the next two years?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasPlanToMigrateIn2Years`,
					props: {
						suggest: {
							typeIncludes: `hasPlanToMigrateIn2Years`
						},
						createOptions: {
							type: `hasPlanToMigrateIn2Years`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "City",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0migrateCity`,
					props: {
						suggest: {
							typeIncludes: `migrateCity`
						},
						createOptions: {
							type: `migrateCity`,
							dataType: "string"
						}
					}
				},
				{
					label: "Country",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0migrateCountry`,
					props: {
						suggest: {
							typeIncludes: `migrateCountry`
						},
						createOptions: {
							type: `migrateCountry`,
							dataType: "string"
						}
					}
				},
				{
					label: "Reason for your change in residence:",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0migrateReason`,
					props: {
						suggest: {
							typeIncludes: `migrateReason`
						},
						createOptions: {
							type: `migrateReason`,
							dataType: "string"
						}
					}
				},
				{
					label: "How long will you be at this new residence?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0migrateDuration`,
					props: {
						suggest: {
							typeIncludes: `migrateDuration`
						},
						createOptions: {
							type: `migrateDuration`,
							dataType: "string"
						}
					}
				},
				{
					label: "Do you plan to return to your current country of residence?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0willReturnAfterMigration`,
					props: {
						suggest: {
							typeIncludes: `willReturnAfterMigration`
						},
						createOptions: {
							type: `willReturnAfterMigration`,
							dataType: "boolean"
						}
					}
				}
			]
		}
	},

	methods: {
		schemaTravelPast2Years(i) {
			return [
				{
					label: `Country`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0past2YearsCountry${i}`,
					props: {
						suggest: {
							typeIncludes: `past2YearsCountry${i}`
						},
						createOptions: {
							type: `past2YearsCountry${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `Cities Visited`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0past2YearsCitiesVisited${i}`,
					props: {
						suggest: {
							typeIncludes: `past2YearsCitiesVisited${i}`
						},
						createOptions: {
							type: `past2YearsCitiesVisited${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `Duration of stay`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0past2YearsDurationOfStay${i}`,
					props: {
						suggest: {
							typeIncludes: `past2YearsDurationOfStay${i}`
						},
						createOptions: {
							type: `past2YearsDurationOfStay${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `Frequency of visits`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0past2YearsFrequency${i}`,
					props: {
						suggest: {
							typeIncludes: `past2YearsFrequency${i}`
						},
						createOptions: {
							type: `past2YearsFrequency${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `Date of last visit`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0past2YearsDateLastVisited${i}`,
					props: {
						suggest: {
							typeIncludes: `past2YearsDateLastVisited${i}`
						},
						createOptions: {
							type: `past2YearsDateLastVisited${i}`,
							dataType: "date"
						}
					}
				},
				{
					label: `Purpose of travel`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0past2YearsPurpose${i}`,
					props: {
						suggest: {
							typeIncludes: `past2YearsPurpose${i}`
						},
						createOptions: {
							type: `past2YearsPurpose${i}`,
							dataType: "string"
						}
					}
				}
			]
		},

		schemaTravelNext2Years(i) {
			return [
				{
					label: `Country`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0next2YearsCountry${i}`,
					props: {
						suggest: {
							typeIncludes: `next2YearsCountry${i}`
						},
						createOptions: {
							type: `next2YearsCountry${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `Cities Visited`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0next2YearsCitiesVisited${i}`,
					props: {
						suggest: {
							typeIncludes: `next2YearsCitiesVisited${i}`
						},
						createOptions: {
							type: `next2YearsCitiesVisited${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `Duration of stay`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0next2YearsDurationOfStay${i}`,
					props: {
						suggest: {
							typeIncludes: `next2YearsDurationOfStay${i}`
						},
						createOptions: {
							type: `next2YearsDurationOfStay${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `Frequency of visits`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0next2YearsFrequency${i}`,
					props: {
						suggest: {
							typeIncludes: `next2YearsFrequency${i}`
						},
						createOptions: {
							type: `next2YearsFrequency${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `Date of last visit`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0next2YearsDateLastVisited${i}`,
					props: {
						suggest: {
							typeIncludes: `next2YearsDateLastVisited${i}`
						},
						createOptions: {
							type: `next2YearsDateLastVisited${i}`,
							dataType: "date"
						}
					}
				},
				{
					label: `Purpose of travel`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0next2YearsPurpose${i}`,
					props: {
						suggest: {
							typeIncludes: `next2YearsPurpose${i}`
						},
						createOptions: {
							type: `next2YearsPurpose${i}`,
							dataType: "string"
						}
					}
				}
			]
		},

		schemaTravelPast14Days(i) {
			return [
				{
					label: `Country`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0past14DaysCountry${i}`,
					props: {
						suggest: {
							typeIncludes: `past14DaysCountry${i}`
						},
						createOptions: {
							type: `past14DaysCountry${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `City`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0past14DaysCity${i}`,
					props: {
						suggest: {
							typeIncludes: `past14DaysCity${i}`
						},
						createOptions: {
							type: `past14DaysCity${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `Arrival Date`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0past14DaysArrivalDate${i}`,
					props: {
						suggest: {
							typeIncludes: `past14DaysArrivalDate${i}`
						},
						createOptions: {
							type: `past14DaysArrivalDate${i}`,
							dataType: "date"
						}
					}
				},
				{
					label: `Departure Date`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0past14DaysDepartureDate${i}`,
					props: {
						suggest: {
							typeIncludes: `past14DaysDepartureDate${i}`
						},
						createOptions: {
							type: `past14DaysDepartureDate${i}`,
							dataType: "date"
						}
					}
				}
			]
		}
	}
}
</script>
